import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { PlusIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { useNotes } from '@/api/hooks/useNotes'
import { StateSwitcher } from '@/components/atoms/state-switcher'
import { EmptyState } from '@/components/molecules/empty-state'
import PageHeader from '@/components/molecules/page-header'
import NotesTable from '@/components/organisms/notes-table'
import { Button } from '@/components/ui/button'
import { useSubscription } from '@/contexts/subscription-context'
import { useIndividuals } from '@/hooks/useIndividuals'

export const Route = createFileRoute('/_authenticated/notes/')({
  component: NotesPage,
})

function NotesPage() {
  const { individualQuery, selectedIndividualId } = useIndividuals()
  const { t } = useTranslation()
  const { data: notes = [] } = useNotes(selectedIndividualId)
  const navigate = useNavigate()
  const { isReadOnly } = useSubscription()

  const goToCreate = () => navigate({ to: '/notes/new' })

  return (
    <div className="space-y-8 z-10">
      <PageHeader body={t('notesPage.header.description')} heading={t('notesPage.header.title')}>
        {notes.length > 0 && (
          <Button disabled={isReadOnly} onClick={goToCreate}>
            <PlusIcon />
            {t('notesPage.header.createNoteButton')}
          </Button>
        )}
      </PageHeader>
      <StateSwitcher
        emptyState={
          <EmptyState
            body={t('notesPage.emptyState.description')}
            ctaText={t('notesPage.header.createNoteButton')}
            ctaType="create-content"
            heading={t('notesPage.emptyState.title')}
            // EmptyState hides its CTA when no handler is given — nothing to offer
            // while notes can't be created.
            onClickCta={isReadOnly ? undefined : goToCreate}
          />
        }
        isEmpty={notes.length === 0}
        isLoading={individualQuery.isLoading}
      >
        <NotesTable notes={notes} />
      </StateSwitcher>
    </div>
  )
}
